import s from './RestaurantHomeFilters.module.sass'

import React, { FC, memo } from 'react'
import { useRouter } from 'next/router'

import { useAppSelector } from '@app/model/store'

import { RestaurantQuickFilter } from '@widgets/Restaurant/RestaurantQuickFilter'

import { RestaurantFilters } from '@features/Restaurant/RestaurantFilters'
import { TypeOutput } from '@features/Restaurant/RestaurantFilters/model/types'

import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { SectionTitle } from '@shared/ui/Layout/SectionTitle'

const RestaurantHomeFilters: FC = () => {
  const router = useRouter()
  const storeCityRead = useAppSelector((state) => state.global.cityRead)

  const handleFilterData = (data: TypeOutput) => {
    router.push(
      `/${router.query.city_slug}/restaurants/restaurant_list/${data.urlQuery}`,
      `/${router.query.city_slug}/restaurants/restaurant_list/${data.urlQuery}`,
      { scroll: false },
    )
  }

  const sectionTitleData = {
    titleText: `Рестораны ${storeCityRead?.genitive_case}`,
    link: `/${storeCityRead?.slug}/restaurants/restaurant_list/`,
  }

  return (
    <ErrorBoundary>
      <div>
        <SectionTitle
          tagTitle={'h1'}
          className={s.quickFilterTitle}
          title={sectionTitleData.titleText}
          link={sectionTitleData.link}
          skeleton={!storeCityRead}
        />

        {/* @ts-ignore */}
        <RestaurantFilters preloadingResults={false} selected={null} handleOutputData={handleFilterData} />

        <RestaurantQuickFilter className={s.quickFilter} />
      </div>
    </ErrorBoundary>
  )
}

export default memo(RestaurantHomeFilters)
